import React from 'react'

import Trainers from '../Components/Trainers/Trainers'

const TrainersPage = () => {
  return (
    <div style={{marginTop: '3rem'}}>
      <Trainers />
 
    </div>
  )
}

export default TrainersPage
